import gql from 'graphql-tag'

export const LOGIN_ADMIN = gql`
    mutation instructorLogin($email: EmailAddress!, $password: String!) {
    instructorLogin(email: $email, password: $password) {
        token
        user {
            id
        }
    }
}
`
